
export function obj ( id ) {
    return document.getElementById(id);
}
export function show ( id ) {
    obj(id).style.display = '';
}
export function hide ( id ) {
    obj(id).style.display = 'none';
}
export function showHide ( id, status ) {
    obj(id).style.display = (status) ? '' : 'none';
}
export function setClass ( id, className ) {
    obj(id).className = className;
}
export function setContent ( id, content ) {
    obj(id).innerHTML = content;
}
export function val ( id ) {
    return obj(id).value;
}
export function isFieldEmpty ( id ) {
    return val(id).length < 1;
}
export function setFocus ( id ) {
    obj(id).focus();
}
export function scrollByDistanceNoDelay ( scrollDistance ) {
    window.scrollBy(0, scrollDistance);
}
export function scrollByHeight ( id ) {
    scrollByDistance(obj(id).clientHeight, 0);
}
export function scrollByDistance ( scrollDistance, mobileOffset ) {
    if (isMobileView()) {
        scrollDistance += mobileOffset;
    }
    var scrollDuration   = 600;
    var scrollDelay      = 15;
    var scrollIterations = (scrollDuration / scrollDelay);
    var scrollStep       = scrollDistance / scrollIterations;
    var scrollPosition   = window.scrollY;
    var scrollInterval   = setInterval(function(){
        if (scrollIterations-- > 0) {
            scrollPosition += scrollStep;
            window.scrollTo(0, scrollPosition);
        } else {
            clearInterval(scrollInterval);
        }
    }, scrollDelay);
}

export function isMobileView () {
    return (window.innerWidth <= 800);
}

export function logError ( msg, source ) {
    if(!source){
        var source = "";
    }
    console.error(source, msg);
}


// Speed up calls to hasOwnProperty
var hasOwnProperty = Object.prototype.hasOwnProperty;

export function isEmpty(obj) {

    // null and undefined are "empty"
    if (obj == null) return true;

    // Assume if it has a length property with a non-zero value
    // that that property is correct.
    if (obj.length > 0)    return false;
    if (obj.length === 0)  return true;

    // If it isn't an object at this point
    // it is empty, but it can't be anything *but* empty
    // Is it empty?  Depends on your application.
    if (typeof obj !== "object") return true;

    // Otherwise, does it have any properties of its own?
    // Note that this doesn't handle
    // toString and valueOf enumeration bugs in IE < 9
    for (var key in obj) {
        if (hasOwnProperty.call(obj, key)) return false;
    }

    return true;
}